import { BeaconInstance } from '../types';
import { getLastEvent, getSelector } from '../utils/helpers';
import { EVENT_CODES } from './constrants';

interface ErrorReportInitOptions {
  openErrorReport: boolean;
}

export default class ErrorReport {
  private readonly beacon: BeaconInstance;

  constructor(beacon: BeaconInstance) {
    this.beacon = beacon;
  }

  interceptUnhandledrejectionError() {
    const self = this;
    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
      if (event) {
        const lastEvent = getLastEvent();
        const selector = lastEvent && getSelector(lastEvent.path);
        let message = event?.reason?.message;
        if (!message) {
          try {
            message = JSON.stringify(event.reason);
          } catch (err) {}
        }
        const result = {
          type: 'unhandledrejection', // 未捕获的promise
          message, // 异常信息
          error: event?.reason?.name, // 异常名称
          stack: event?.reason?.stack, // 异常堆栈信息
          lastEventSelector: selector,
          lastEventType: lastEvent && lastEvent.type,
        };
        self.beacon.onUserAction(EVENT_CODES.ERROR_REPORT_EVENT, result);
      }
    });
  }

  interceptJsError() {
    const self = this;
    window.addEventListener(
      'error',
      (event: ErrorEvent) => {
        if (event) {
          const target = event.target;
          const isElementTarget = target instanceof HTMLElement;
          let message = event?.message;
          // 如果是资源加载导致的，message会是undefined
          if (isElementTarget && (target as HTMLElement)?.localName?.toLowerCase() === 'script') {
            message = 'Failed to load script: ' + (target as HTMLScriptElement)?.src;
          } else if (
            isElementTarget &&
            (target as HTMLElement)?.localName?.toLowerCase() === 'link'
          ) {
            message = 'Failed to load stylesheet: ' + (target as HTMLLinkElement)?.href;
          }
          const lastEvent = getLastEvent();
          const selector = lastEvent && getSelector(lastEvent.path);
          const result = {
            type: 'error', // js错误
            message, // 异常信息
            error: event?.error?.name, // 异常名称
            stack: event?.error?.stack, // 异常堆栈信息
            lastEventSelector: selector, // 用户最后一次操作的地方
            lastEventType: lastEvent && lastEvent.type, // 用户最后一次操作事件的类型
          };
          self.beacon.onUserAction(EVENT_CODES.ERROR_REPORT_EVENT, result);
        }
      },
      true
    );
  }

  public init({ openErrorReport }: ErrorReportInitOptions) {
    if (!openErrorReport) {
      return;
    }
    this.interceptJsError();
    this.interceptUnhandledrejectionError();
  }
}
